import React from 'react';
import { Modal, ModalHeader, ModalBody } from '@wk/components-react16';

const PrivilegesDetails = ({ isPrivilegesOpen, setIsPrivilegesOpen }: any) => {
    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsPrivilegesOpen(false);
        }
    }

    return (
        <Modal
            isOpen={isPrivilegesOpen}
            srLabelledBy={'modal-id-001'}
            srDescribedBy={'modal-id-002'}
            onUserRequest={handleUserRequest}>
            <ModalHeader
                titleId={'modal-id-001'}
                isFullscreenButtonVisible
                onUserRequest={() => handleUserRequest('header')}>
                Privileges details{' '}
            </ModalHeader>
            <ModalBody descriptionId="modal-id-002">
                <div className="wk-row">
                    <div className="wk-col-12">
                        <table className="wk-table wk-table-bordered wk-table-small">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>USER_MANAGEMENT</td>
                                    <td>Ability to access user and role management and add/edit/view user</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default PrivilegesDetails;
